import styled from 'styled-components'

export const BusinessOnboardingPage = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
`

export const BusinessOnboardingMain = styled.div`
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
`

// header things:
export const BusinessOnboardingHeader = styled.div`
  width: 354px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 5px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  @media (min-width: 768px) {
    width: 480px;
    margin-top: 40px;
  }
`

export const BusinessOnboardingHeaderTabs = styled.div`
  font-size: 12px;
  background: ${(props) =>
    props?.selected ? 'linear-gradient(to right, #6977DF, #CA98FF)' : '#f5f7fa'};
  color: ${(props) => (props?.selected ? '#fff' : 'rgb(89, 110, 146)')};
  height: 30px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  cursor: default;
  align-items: center;
  position: relative;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const BusinessOnboardingHeaderTabsShapeOne = styled.div`
  width: 7px;
  height: 30px;
  border-top: 15px solid #fff;
  border-bottom: 15px solid #fff;
  border-left: 7px solid #fff;
`

// body things:
export const BusinessOnboardingBody = styled.div`
  width: 335px;
  @media (min-width: 768px) {
    width: 475px;
  }
  margin: 0 auto;
`

export const BusinessOnboardingBodyHeading = styled.h1`
  margin-bottom: 19px;
  font-weight: 700;
  font-size: 29px;
  line-height: 38px;
  color: rgb(34, 47, 45);
`

export const BusinessOnboardingBodyDescription = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: rgb(69, 74, 94);
  margin-bottom: 31px;
`

export const BusinessOnboardingBodyPlan = styled.div`
  width: 100%;
  padding: 40px 23px 35px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(224, 232, 243);
  border-radius: 15px;
  position: relative;
  transition: all 0.5s ease-in-out;
  margin-bottom: 31px;
  cursor: ${(props) => (props?.notselected ? 'pointer' : 'default')};
`

export const BusinessOnboardingBodyTitle = styled.span`
  font-weight: 700;
  font-size: 29px;
  line-height: 38px;
  color: rgb(34, 47, 45);
`

export const BusinessOnboardingBodyPriceSpan = styled.span`
  font-weight: ${(props) => (props?.main ? '700' : '400')};
  font-size: ${(props) => (props?.main ? '24px' : '16px')};
  line-height: ${(props) => (props?.main ? '38px' : '20px')};
  color: ${(props) => (props?.main ? 'rgb(34, 47, 45)' : 'rgb(69, 74,94)')};
  margin-right: ${(props) => (props?.main ? '5px' : '0')};
  margin-bottom: ${(props) => (props?.main ? '0' : '3px')};
`

export const BusinessOnboardingBodyDescriptionList = styled.div`
  margin-bottom: ${(props) => (props?.heading ? '10px' : '0')};
  font-size: 16px;
  line-height: 20px;
  font-weight: ${(props) => (props?.heading ? '500' : '400')};
  color: ${(props) => (props?.heading ? 'rgb(34,47,45)' : 'rgb(69,74,94)')};
`

export const BOBPlanAppAccessContainer = styled.div`
  width: 100%;
  border-radius: 9px;
  padding: 13px;
  border: 1px solid rgb(113, 127, 157);
  margin-bottom: 20px;
`

export const BOBPlanRecommendedTag = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 15px 0 15px;
  background: #c395fc;
  color: #fff;
  font-weight: 500;
  padding: 3px 6px;
`

// selection component

export const BusinessOnboardingSingleSelectContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(117, 138, 174);
  min-height: 55px;
  color: rgb(34, 47, 45);
  font-size: 16px;
  font-weight: 400px;
  border-radius: 9px;
  padding: 0 17px;
  cursor: pointer;
`

export const BusinessOnboardingSingleSelectOptionsContainer = styled.div`
  border-radius: 9px;
  padding: 5px;
  width: ${(props) => (props?.considerPadding ? '289px' : '335px')};
  @media (min-width: 768px) {
    width: ${(props) => (props?.considerPadding ? '429px' : '475px')};
  }
`

export const BusinessOnboardingBodyPlanSelectorArrow = styled.img`
  width: 15px;
  transform: ${(props) => props?.menuOpen && 'rotate(-180deg)'};
  transition: all 0.3s ease-in-out;
`

export const BusinessOnboardingBodyPlanSelectorText = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: rgb(34, 47, 45);
  margin-right: 9px;
  ${(props) => props?.bold && 'font-weight: 500;'};
  ${(props) => props?.gray && 'color: rgb(89,110,146);'};
  ${(props) => props?.green && 'color: rgb(71,162,3);'};
`

export const BusinessOnboardingSingleSelectOption = styled.div`
  display: flex;
  align-items: center;
  background: ${(props) => (props?.selected ? '#EFEFEF' : '#FFF')};
  height: 55px;
  color: rgb(34, 47, 45);
  font-size: 16px;
  font-weight: 400px;
  cursor: pointer;
  padding: 17px;
  border-radius: 5px;
  &:hover {
    background: #0098ff;
    color: #fff;
    ${BusinessOnboardingBodyPlanSelectorText} {
      color: #fff;
    }
  }
`

// input

export const BusinessOnboardingInput = styled.input`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(117, 138, 174);
  height: 55px;
  color: rgb(34, 47, 45);
  font-size: 16px;
  font-weight: 400px;
  border-radius: 9px;
  padding: 0 17px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

// submit button

export const BusinessOnboardingSubmitButton = styled.button`
  background: #737be3;
  color: #fff;
  width: 100%;
  cursor: pointer;
  font-weight: 700;
  border-radius: 10px;
  padding: 0 5px;
  font-size: 17px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease-in-out;
  &:disabled {
    background: #bdc0e3;
  }
`
